import React from 'react'
import MinistryStatsComponent from '../lib/components/ministry-stats'
import { ITranslationsProvided, withTranslations } from '../lib/connectors/translation'

interface StatItem {
  value: string;
  label: string;
  sublabel?: string;
  icon?: string;
  imageUrl?: string;
}

interface IProps {
  title: string;
  description?: string;
  statistics: StatItem[];
  verticalAlignment?: 'start' | 'center' | 'end';
}

const MinistryStats: React.FC<IProps & ITranslationsProvided> = ({
  title,
  description,
  statistics,
  verticalAlignment,
}) => {
  return (
    <MinistryStatsComponent
      title={title}
      description={description}
      statistics={statistics}
      verticalAlignment={verticalAlignment}
    />
  )
}

export default withTranslations(MinistryStats) 